<template>
  <div class="password-change">
    <h2>新しいパスワード</h2>
    <div class="cont">
      <h3>これから使用するパスワードを設定してください</h3>
      <p>※ 6桁以上で設定してください</p>
      <form @submit.prevent="formAction">
        <b-form-group
          id="new-password"
          class="form-part"
          label="パスワード"
          label-for="password">
          <b-form-input
            v-model="password"
            id="password"
            type="password"
            required
            placeholder="パスワード"></b-form-input>
        </b-form-group>
        <b-form-group
          id="new-password"
          class="form-part"
          label="パスワード再確認"
          label-for="password">
          <b-form-input
            v-model="confirmPassword"
            id="password"
            type="password"
            required
            placeholder="パスワード"></b-form-input>
        </b-form-group>
        <p class="form-button">
          <b-button type="submit" variant="primary">設定する</b-button>
        </p>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
  },
  data () {
    return {
      password: '',
      confirmPassword: ''
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
    formAction() {
      if (this.$route.query.email && this.password == this.confirmPassword && this.password.length > 0) {
        apiClient.resetPassword({
          password: this.password,
          email: this.$route.query.email
        }).then(response => {
          this.$router.push({ name: 'passwordreset_success' })
        })
      }
    }
  },
}
</script>
<style scoped lang="scss">
.password-change {
  text-align: center;
  padding-left: 4vw;
  padding-right: 4vw;
  h2 {
    font-size: 3.7vw;
    font-weight: bold;
    line-height: 1.5;
    padding-top: 3vw;
    padding-bottom: 3vw;
    border-bottom: 1px solid $blue;
  }
  .cont {
    padding-top: 7.4vw;
    h3 {
      font-size: 3.7vw;
      line-height: 1.5;
    }
    p {
      text-align: left;
    }
    .form-part {
      text-align: left;
      margin-top: 8vw;
    }
    .form-button {
      text-align: right;
      margin-top: 14.9vw;
      button {
        background-color: $light-blue;
        border: 0;
        height: 13.8vw;
        width: 35.7vw;
        text-align: center;
        border-radius: 6.9vw;
        font-size: 4.2vw;
      }
    }
  }
}
</style>